import React from "react";
import Banner from "./Banner";
import About from "./About";
import Services from "./Services";
import Feature from "./Feature";
import Goals from "./Goals";
import Testimonial from "./Testimonial";
import TopProd from "./TopProd";
import Testimonials from "./Testimonials";
import WhyChoose from "./WhyChoose";
import SaasProducts from "./SaasProduct";
import ResourcesUpdate from "./ResourseUpdate";

function Home() {
  return (
    <div>
      <Banner />
      <About />
      <Services />
      <Feature />
      <TopProd />
      <WhyChoose />
      <SaasProducts />
      <Goals />
      <ResourcesUpdate />

      <Testimonial />
     
    </div>
  );
}

export default Home;
